import type { ReduxApplicationState } from 'src/redux/combinedReducer';

export const selectCurrentMedia = (state: ReduxApplicationState) =>
  state.productMediaCarousel.currentMedia;

export const selectNavigatedBy = (state: ReduxApplicationState) =>
  state.productMediaCarousel.navigatedBy;

export const selectIsModalOpen = (state: ReduxApplicationState) =>
  state.productMediaCarousel.isModalOpen;
